import React from 'react';
import UIComponent from 'components/UiComponent';
import {withTranslation} from "react-i18next";

const LoginButtonSwitch  = (props) => {

    const getButtonText = () => {
        switch(props.buttonType){
            case "close":
                return props.t("lbl.CLOSE_SESSION","Close Session")
            case "authenticate":
                return props.t("lbl.AUTHENTICATE_WITH","Authenticate with")
        }
    }
    
    const generateDemandedButton = () => {
        switch(props.type){
            case "MacID":
                return (
                    <UIComponent 
                        id="macid_login" 
                        component="smart-button" 
                        class="btn btn__macid_auth btn__no-border" 
                        type="button"
                        triggeredText={props.t("lbl.AUTHENTICATING","Authenticating...")}
                        state={props.actionObserver ? "triggered" : "active"}
                        onClick={props.onClick}
                    > 
                        {getButtonText()} {props.type} 
                    </UIComponent>
                )
            case "LdapID":
                return (
                    <UIComponent 
                        id="ldapid_login" 
                        component="smart-button" 
                        class="btn btn__macid_auth btn__no-border" 
                        type="button"
                        triggeredText={props.t("lbl.CLOSING_SESSION","Closing session...")}
                        state={props.actionObserver ? "triggered" : "active"}
                        onClick={props.onClick}
                    > 
                        {getButtonText()} 
                    </UIComponent>
                )
            case "CCID":
                return (
                    <UIComponent 
                        id="ccid_login" 
                        component="smart-button" 
                        class="btn btn__macid_auth btn__no-border" 
                        type="button"
                        triggeredText={props.t("lbl.AUTHENTICATING","Authenticating...")}
                        state={props.actionObserver ? "triggered" : "active"}
                        onClick={props.onClick}
                    > 
                        {props.t("lbl.SSO_AUTHENTICATION")} 
                    </UIComponent>
                )
        }
    }

    return(
        <React.Fragment>
            {generateDemandedButton()}
        </React.Fragment>
    )
}
export default withTranslation()(LoginButtonSwitch);